<template>
  <span
    class="inline-flex gap-4"
    :disabled="disabled"
    data-disabled="true"
    :class="{
      'cursor-not-allowed': disabled,
      'cursor-pointer': !disabled,
    }"
    @click="methodToggle"
    >
    <span
      class="flex items-center h-6 aspect-[1.7/1] p-1 rounded-full"
      :class="{
        'bg-sky-900/10': !model && !disabled,
        'bg-sky-900/20': model && !disabled,
        'bg-gray-400/20': !model && disabled,
        'bg-sky-800/10': model && disabled,
      }"
      >
      <span
        class="h-full aspect-square rounded-full"
        :class="{
          'bg-gray-400': !model && !disabled,
          'bg-sky-900': model && !disabled,
          'bg-gray-300': !model && disabled,
          'bg-sky-900/30': model && disabled,
        }"
        :style="computedStyle"
        />
    </span>

    {{ text }}
    <slot />
  </span>
</template>

<script setup lang="ts">
const props = defineProps<{
	disabled?: boolean
  text?: string
}>()

const model = defineModel()

const methodToggle = () => {
  if (props.disabled) return

  model.value = !model.value
}

const computedStyle = computed(() => {
  return model.value
    ? 'margin-left:auto;'
    : 'margin-right:auto;'
})
</script>
